module.exports = __webpack_public_path__ + "static/media/Around Again Cover Art.db820c98.jpg";